import * as db from './firebase'

export default db


// WEBPACK FOOTER //
// ./src/db/index.jsx